import ElementHeaderText from './ElementHeaderText';
export * from './ElementHeaderText';
export default ElementHeaderText;
